export default "__VITE_ASSET__CiYihhDj__"